import { Button } from "primereact/button";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { useToggle } from "../../../../hooks/useToggle";
import localeText from "../../../../locale";
import AnswerModal from "./components/AnswerModal";
import AskModal from "./components/AskModal";
import Question from "./components/Question";
import QuestionsModal from "./components/QuestionsModal";
import useGetQuestions from "./hooks/useGetQuestions";
import useReplyQuestion from "./hooks/useReplayQuestion";
import useApiStatus from "../../../../hooks/useApiStatus";

const ProductQuestionsArea = ({
  productInfoID,
  productOwner,
  productOwnerFirstName,
  productQuestionsRef,
}) => {
  const { showErrorToast } = useToastContext();
  const { value, setAsFalse, setAsTrue } = useToggle();
  const {
    value: isVisibleAnswerModal,
    setAsFalse: setNotVisibleAnswerModal,
    setAsTrue: setVisibleVisibleAnswerModal,
  } = useToggle();
  const {
    value: isVisibleAskModal,
    setAsFalse: setNotVisibleAskModal,
    setAsTrue: setVisibleAskModal,
  } = useToggle();
  const { questions, isLoading, setQuestions } = useGetQuestions({
    productId: productInfoID,
    onError: (code) => showErrorToast({ code }),
  });
  const {
    answer,
    setAnswer,
    isLoading: isLoadingAnswer,
    postAnswer,
    setCurrentQuestion,
    currentQuestion,
  } = useReplyQuestion({
    idProduct: productInfoID,
    setAsFalse: setNotVisibleAnswerModal,
    setQuestions,
    questions,
  });
  const { isLoading: isLoadingAnwserModal, setIsLoading: setIsLoadingAnwserModal } = useApiStatus();
  const history = useHistory();
  const location = history?.location;
  const params = new URLSearchParams(location?.search);
  const questionId = params?.get("questionId");

  const handleSetVisibleAskModal = () => {
    const username = localStorage.getItem("__extraconomy_username");
    if (username) {
      setVisibleAskModal();
      return;
    }
    const { pathname, search } = location;
    const from = `${pathname}${search}`;
    history.push("/login", { from });
  };

  useEffect(() => {
    const isOwnerProduct = productOwner === localStorage.getItem("__extraconomy_username");
    const from = `${location.pathname}${location.search}`;
    if (!isOwnerProduct && questionId) history.push("/login", { from });

    if (questionId && questions && questions.length > 0 && isOwnerProduct) {
      setIsLoadingAnwserModal(true);
      setVisibleVisibleAnswerModal();

      const currentQuestionFound = questions.find((q) => q.id === Number(questionId));
      setCurrentQuestion({
        id: Number(questionId),
        question: currentQuestionFound?.question,
        firstName: currentQuestionFound?.user?.firstname,
        dateQuestion: currentQuestionFound?.dateQuestion,
        answer: currentQuestionFound?.answer,
        dateAnswer: currentQuestionFound?.dateAnswer,
        productOwnerFirstName: productOwnerFirstName,
      });
      setIsLoadingAnwserModal(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId, questions]);

  if (isLoading) return <Loading />;
  const firstFiveQuestions = questions.slice(0, 5);
  const isNotProductOwner = productOwner !== localStorage.getItem("__extraconomy_username");

  return (
    <>
      <QuestionsModal
        headerText={`${localeText("questionsAndAnswers")} (${questions.length})`}
        setAsFalse={setAsFalse}
        visible={value}
        questions={questions}
        onwerProduct={productOwner}
        isLoading={isLoading}
        productOwnerFirstName={productOwnerFirstName}
      />
      <AskModal
        headerText={`${localeText("doQuestion")}`}
        setAsFalse={setNotVisibleAskModal}
        visible={isVisibleAskModal}
        idProduct={productInfoID}
        setAsTrue={setVisibleAskModal}
        setQuestions={setQuestions}
      />
      {questionId && (
        <AnswerModal
          visible={isVisibleAnswerModal}
          isLoadingAnwserModal={isLoadingAnwserModal}
          setAsFalse={setNotVisibleAnswerModal}
          headerText={`${localeText("reply")}`}
          setAnswer={setAnswer}
          answer={answer}
          isLoading={isLoadingAnswer}
          postAnswer={postAnswer}
          currentQuestion={currentQuestion}
        />
      )}

      <div ref={productQuestionsRef} id="productQuestions" className={``}>
        <div className="py-3 mb-5" style={{ borderTop: "1px solid #B3BAC5" }}>
          {firstFiveQuestions.length > 0 ? (
            <div className="font-bold text-lg" style={{ color: "#344563" }}>
              {localeText("questionsAndAnswers")} {/* ({questions.length}) */}
            </div>
          ) : (
            <div className="font-bold text-lg" style={{ color: "#344563" }}>
              {localeText("doTheFirstQuestion")}
            </div>
          )}
        </div>
        {/*  {(isNotProductOwner || (!isNotProductOwner && firstFiveQuestions.length > 0)) && <hr />} */}

        {firstFiveQuestions.length > 0 && (
          <div className="font-semibold mb-3" style={{ color: "#091E42" }}>
            {localeText("lastQuestions")}
          </div>
        )}

        {firstFiveQuestions && firstFiveQuestions.length !== 0 && (
          <>
            <div className="flex flex-column gap-3">
              {firstFiveQuestions.map((question, i) => (
                <Question
                  key={i}
                  question={question.question}
                  firstName={question.user.firstname}
                  dateQuestion={question.dateQuestion}
                  onwerProduct={productOwner}
                  questionId={question.id}
                  answer={question?.answer}
                  dateAnswer={question?.dateAnswer}
                  productOwnerFirstName={productOwnerFirstName}
                />
              ))}
            </div>
          </>
        )}
        <div className="flex flex-column gap-2 mt-4">
          {isNotProductOwner && (
            <Button
              link
              className="p-0 text-sm p-no-outline"
              style={{ color: "#245AE5", textDecoration: "underline" }}
              onClick={handleSetVisibleAskModal}
            >
              {localeText("doQuestionToSeller")}
            </Button>
          )}
          {questions.length > 5 && (
            <Button
              link
              className="p-0 text-sm p-no-outline"
              style={{ color: "#245AE5" }}
              onClick={setAsTrue}
            >
              {localeText("showMore")}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductQuestionsArea;
